const LOYALTY_TAB_IDS = ["challenges", "leaderboard", "rewards"] as const;

export type LoyaltyTabId = (typeof LOYALTY_TAB_IDS)[number];

export const isValidLoyaltyTab = (
  value: string | null,
): value is LoyaltyTabId =>
  value !== null && LOYALTY_TAB_IDS.includes(value as LoyaltyTabId);
